class LocationBasedPopup extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector(".popup-content--close-btn");
    this.countryShowed = this.dataset.countryShowed;
    this.capping = this.dataset.capping;
    this.popupId = this.dataset.popupId;
    this.page = this.dataset.page;

    this.init();
  }

  async init() {
    const popupHasBeenShowed = this.readCookie(this.popupId);
    if (popupHasBeenShowed) return;

    const userCountry =
      this.countryShowed == "worldwide" ? "worldwide" : await this.fetchUserCountry();

      if (this.countryShowed == "worldwide" || this.countryShowed == userCountry) {
        if (this.page == 'default' || window.location.href.indexOf("/collections/shop") > -1) {
        this.togglePopup(true);
        this.initCloseBtn();
        // this.createCookie(this.popupId, 1, this.capping);
      }
    }
  }

  async fetchUserCountry() {
    try {
      const response = await fetch("/browsing_context_suggestions.json");
      const json = await response.json();
      const countryHandle = json?.detected_values?.country.handle;

      return countryHandle;
    } catch (error) {
      console.error("Error fetching user country:", error);
    }
  }

  initCloseBtn() {
    this.closeBtn.addEventListener("click", () => this.togglePopup(false));
    document.getElementById("location-based-popup-backdrop").addEventListener("click", () => this.togglePopup(false));
  }

  togglePopup(visible) {
    visible ? this.classList.remove('hidden') : this.classList.add('hidden');
    document.getElementById("location-based-popup-backdrop").style.display = visible ? "block" : "none";
    document.body.style.overflow = visible ? "hidden" : "initial";
    document.querySelector('.page-body-content').style.pointerEvents = visible ? "none" : "auto";
  }

  createCookie(name, value, days) {
    const expires = days
      ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toGMTString()}`
      : "";
    document.cookie = `${name}=${value}${expires}; path=/`;
  }

  readCookie(name) {
    const nameEQ = `${name}=`;
    return (
      document.cookie
        .split(";")
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(nameEQ)) || ""
    ).slice(nameEQ.length);
  }
}

customElements.define("location-based-popup", class extends LocationBasedPopup  { });
customElements.define("location-based-popup-second", class extends LocationBasedPopup  { });